import { createContext, useContext, useEffect, useState } from 'react';

// Note: matched to actual grid usablewidth (not width of screen)
export const containerBreakpoints = {
  xl: 1400,
  lg: 1000,
  md: 768,
  sm: 600
};

export type BreakpointKey = 'sm' | 'md' | 'lg' | 'xl';

interface BreakpointContextType {
  breakpoint: BreakpointKey;
  setBreakpoint: (bp: BreakpointKey) => void;
}

const BreakpointContext = createContext<BreakpointContextType | undefined>(undefined);

export const BreakpointProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [breakpoint, setBreakpoint] = useState<BreakpointKey>(() => {
    return getBreakPoint();
  });

  useEffect(() => {
    const handleResize = () => {
      setBreakpoint(getBreakPoint());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <BreakpointContext.Provider value={{ breakpoint, setBreakpoint }}>
      {children}
    </BreakpointContext.Provider>
  );
};

const getBreakPoint = (): BreakpointKey => {
  const width = window.innerWidth;
  if (width >= 1400) return 'xl';
  if (width >= 1000) return 'lg';
  if (width >= 768) return 'md';
  return 'sm';
};

export const useBreakpoint = (): BreakpointContextType => {
  const context = useContext(BreakpointContext);
  if (!context) {
    throw new Error('useBreakpoint must be used within a BreakpointProvider');
  }
  return context;
};
